export type { SeasonField, SeasonFieldPageable } from '@protector/entities/season-field/models';

export { SeasonFieldQueryKey } from '@protector/entities/season-field/constants';

export const SEASON_FIELDS = 'SEASON_FIELDS';

export interface SeasonFieldParams {
  include_deleted?: boolean;
  propertyIds?: string[];
  seasonIds?: string[];
  enabled?: boolean;
}

export interface SeasonFieldServiceParams extends SeasonFieldParams {
  include_deleted?: boolean;
  fieldIds?: string[];
  update?: boolean;
}
